import { useContext } from 'react';
import Cookies from 'universal-cookie';
import { getCategoriaFornecedor } from '../../../../../../../controllers/fornecedores';
import TagManager from 'react-gtm-module';

//controllers
import Config from '../../../../../../../controllers/config';
import Pessoas_controller from '../../../../../../../controllers/pessoa';
import Qualidade_controller from '../../../../../../../controllers/qualidade';
import Log from '../../../../../../../controllers/log';
import { AuthContext } from '../../../../../../../contexts/AuthContext';

export default (props) => {

    const loadData = async (categoriaFornecedor) => {
        props.setState({isLoading: true});

        if(categoriaFornecedor === 'acessorios') {
            await props.loadAcessorios(0,props.state.rowsPerPageAcessorios);
        }

        if(categoriaFornecedor === 'moveis') {
            await props.loadMoveis(0,props.state.rowsPerPageMoveis);
        }

        props.setState({isLoading: false});
    };
    
    const handleChangeSelectFornecedores = async (event,newvalue) => {
        
        let fornec = null;
        
        if (newvalue == null) {
            fornec = props.state.fornecedor;
        } else {
            fornec = newvalue.ID_PESSOA;
        }
        await props.setState({
            fornecedor: fornec,
            firstLoad: true
        });

        await loadCategoriaFornecedor();
        
        await props.setState({firstLoad: false});
    };

    const loadSituacoes = async () => {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');
        
        try {
            const o_situacoes = await Qualidade_controller.getSituacoes(token);
            let j_o_situacoes = JSON.parse(o_situacoes.body);

            if (o_situacoes.res.statusCode === 200) {
                
                j_o_situacoes.unshift({ id: 0, nome: "Selecione uma situação" });
                props.setState({opcoesSituacoes: j_o_situacoes});

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:situacoes',
                //       eventAction: 'callback',
                //       eventLabel: 'sucesso:lista-situacoes',
                //     }
                // });
                
            } else {
                if (
                    o_situacoes.res.statusCode === 200 && 
                    j_o_situacoes.message && 
                    j_o_situacoes.message.includes("Token inválido!")
                ) {
                    this.child.current.retorno('Autentificação inválida!','error');
                    setTimeout(function() {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            props.childAlert.current.retorno('Erro ao carregar dados!','error');
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:qualidade',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }
    };
    
    const handlerChangeTab = async (event, newValue) => {
        await props.setState({valueTab: newValue});
        await loadCategoriaFornecedor(newValue);

        if (newValue === 'acessorios') {
            TagManager.dataLayer({
                dataLayer: {
                  event: 'event',
                  eventCategory: 'tokstok:fornecedores:qualidade',
                  eventAction: 'clique:aba',
                  eventLabel: 'acessorios',
                }
            });
        }
        if (newValue === 'moveis') {
            TagManager.dataLayer({
                dataLayer: {
                  event: 'event',
                  eventCategory: 'tokstok:fornecedores:qualidade',
                  eventAction: 'clique:aba',
                  eventLabel: 'moveis',
                }
            });
        }
    };
    
    const handlerChangeIndex = (index) => {
        props.setState({valueTab: index});
    };
    
    const handlerModalCloseUpFichaTecnica = () => {
        props.setState({openModalUpFichaTecnica: false});
    };

    const loadFornecedores = async () => {
        const cookies = new Cookies();
        const token = cookies.get('User-Token');

        if(props.state.fornecedor !== 0) {
            props.handlerCleanFiltersAcessorios();
        }

        try {
            const r_fornecedores = await Pessoas_controller.getFornecedores(token);
            const j_r_fornecedores = JSON.parse(r_fornecedores.body);
            if (r_fornecedores.res.statusCode === 200) {
                props.setState({
                    fornecedores: j_r_fornecedores.itens,
                    totalRowsAcessorios: 0,
                    dataAcessorios: [],
                    dataAcessoriosSelected: [],
                    
                    totalRowsMoveis: 0,
                    dataMoveis: [],
                    dataMoveisSelected: [],
                });

                // TagManager.dataLayer({
                //     dataLayer: {
                //       event: 'event',
                //       eventCategory: 'tokstok:fornecedores:qualidade',
                //       eventAction: 'callback',
                //       eventLabel: `sucesso:lista-fornecedores`,
                //     }
                // });
            } else {
                if (
                    j_r_fornecedores.status == false && 
                    j_r_fornecedores.message && 
                    j_r_fornecedores.message.includes("Token inválido!")
                ) {
                    props.childAlerta.current.retorno('Autentificação inválida!','error');
                    setTimeout(() => {
                        window.location.reload();
                    }, 1000);
                } else {
                    throw new Error("Campos necessários, não foram retornados pelo servidor!");
                }
            }
        } catch (error) {
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE")
                errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString
            });
            props.childAlerta.current.retorno(error.message,'error');

            // TagManager.dataLayer({
            //     dataLayer: {
            //       event: 'event',
            //       eventCategory: 'tokstok:fornecedores:qualidade',
            //       eventAction: 'callback',
            //       eventLabel: `erro:${error.message}`,
            //     }
            // });
        }

    };

    const getListCategorias = (body) => {
        return Object.entries(body).flatMap(value => {
            switch (value[0]) {
                case 'iN_ACESS':
                    if (value[1] === 'S')
                        return 'acessorios' 
                case 'iN_MOVEIS':
                    if (value[1] === 'S')
                        return 'moveis' 
            }
            return []
        })
    }

    const loadCategoriaFornecedor = async (selectedCategoria = null) => {
        const cookies = new Cookies();
        const token = cookies.get("User-Token");

        const idPessoa = props.isVisaoTok ? props.state.fornecedor : 0;
    
        await getCategoriaFornecedor({ token, params: { idPessoa } })
        .then(async (response) => {
            const body =  JSON.parse(response.body);
            const categorias = getListCategorias(body)
            
            props.setState({ 
                categoriaFornecedor: categorias,
                valueTab: selectedCategoria || categorias[0],
                escolhaGrupo: 0,
                escolhaFamilia: 0
            });
            await loadData(selectedCategoria || categorias[0]);
        })
        .catch((error) => {
            let errorString = "Erro ao carregar dados!";
            if (Config.DEBUG === "TRUE") errorString = error.message;
            props.setState({
                isError: true,
                isLoading: false,
                error: errorString,
            });
            props.childAlerta.current.retorno(error.message, "error");
        });
    };

    const toggleSnackbarFilterValidation = () => {
        props.setState({
            isOpenSnackbarFilterValidation: !props.state.isOpenSnackbarFilterValidation
        });
    };

    const setMessageSnackbarFilterValidation = (message = "") => {
        props.setState({ messageSnackbarFilterValidation: message });
    };

    return {
        loadSituacoes,
        handlerChangeTab,
        handlerChangeIndex,
        handlerModalCloseUpFichaTecnica,
        handleChangeSelectFornecedores,
        loadCategoriaFornecedor,
        loadFornecedores,
        toggleSnackbarFilterValidation,
        setMessageSnackbarFilterValidation,
    };
};